import React from 'react';
import { Icon } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import { userIcon } from '../constants';

const UserIcon = ({ archived, approved }) => {
  const intl = useIntl();
  const item = userIcon({ archived, approved });
  return (<Icon name={item.icon} className={item.color} title={intl.formatMessage({ id: item.message })} />);
};

export default UserIcon;
